import * as React from "react"
import {useSignal} from "@preact/signals-react";
import {Box, Grid} from "@mui/material";
import {SwitchSeeker} from "@ui-seeker/core";

import {useRepricingFormData} from "../../@hooks";
import RepricingCrudFormTitleRow from "../TitleRow";
import RepricingFormWeekdaysSelect from "./Weekdays";
import RepricingFormHoursSelect from "./Hour";
import RepricingFormDateRange from "./DateRange";


export default function RepricingCrudFormScheduleRow() {
	const { haveSchedule } = useRepricingFormData()
	const showSchedule = useSignal(haveSchedule)

	return <>
		<Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
				<Box>
					<RepricingCrudFormTitleRow
						icon="calendar-clock"
						title="Schedule"
						subtitle="Establish the timing for the rule's application"
					/>
				</Box>

				<SwitchSeeker
					checked={showSchedule.value}
					onChange={e => showSchedule.value = e.target.checked}
				/>
			</Grid>

		<Grid item xs={4}>
			<RepricingFormHoursSelect enabled={showSchedule.value} />
		</Grid>

		<Grid item xs={4}>
			<RepricingFormWeekdaysSelect enabled={showSchedule.value} />
		</Grid>

		<Grid item xs={4}>
			<RepricingFormDateRange enabled={showSchedule.value} />
		</Grid>
	</>
}